import { SlidersHorizontal } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Slider } from "@/components/ui/slider";

import { INTERACTION_TYPES_FOR } from "../../constants";
import type { SandboxEntityType } from "../../types/entities";
import type { InteractionType } from "../../types/interactions";

const WeightCell = ({
  entityType,
  interactionType,
  value,
  onUpdate,
}: {
  entityType: SandboxEntityType;
  interactionType: InteractionType;
  value: number;
  onUpdate: (v: number) => void;
}) => {
  if (!INTERACTION_TYPES_FOR[entityType].includes(interactionType)) {
    return (
      <td className="px-2 py-1.5 text-center">
        <span className="text-xs text-muted-foreground/40">—</span>
      </td>
    );
  }

  return (
    <td className="px-2 py-1.5 text-center">
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="h-7 px-2 gap-1.5 font-mono text-xs tabular-nums w-16"
          >
            <SlidersHorizontal className="h-3 w-3 shrink-0 text-muted-foreground" />
            {value.toFixed(2)}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-48 p-3 space-y-3" align="center">
          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">Weight</span>
            <span className="text-sm font-mono font-medium tabular-nums">
              {value.toFixed(2)}
            </span>
          </div>
          <Slider
            min={0}
            max={1}
            step={0.05}
            value={[value]}
            onValueChange={([v]) => onUpdate(v)}
          />
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>0</span>
            <span>1</span>
          </div>
        </PopoverContent>
      </Popover>
    </td>
  );
};

export default WeightCell;
